export const SHARED_FILTER_OPTIONS = {
  categories: [
    // Core Design Tools
    'Design',
    'Design Systems',
    'Design Handoff',
    'Wireframing',
    'Prototyping',
    
    // Visual Content
    'Images',
    'Motion',
    'Animation',
    '3D Design',
    'Video',
    'Presentations',
    
    // Research & Testing
    'Research',
    'Testing',
    'Analytics',
    'Information Architecture',
    
    // Development & Technical
    'Development',
    'No-code',
    'Database',
    'CMS',
    'Forms',
    
    // Collaboration & Productivity
    'Collaboration',
    'Communication',
    'Whiteboarding',
    'Project Management',
    'Productivity',
    'Documentation',
    'Notes',
    
    // AI & Automation
    'AI Assistant',
    'AI Code Assistant',
    'AI Search',
    
    // Learning & Growth
    'Learning',
    'Diagramming'
  ],
  useCases: [
    // Design & Creation
    'Design systems',
    'UI design',
    'Wireframing',
    'Prototyping',
    'Visual design',
    'Brand design',
    
    // Content Creation
    'Animation',
    'Video editing',
    'Image editing',
    'Presentations',
    '3D modeling',
    
    // Research & Testing
    'User testing',
    'Usability testing',
    'User research',
    'A/B testing',
    'Analytics',
    'Surveys',
    
    // Development
    'Code generation',
    'Web development',
    'App development',
    'Database management',
    'API development',
    
    // Collaboration & Management
    'Collaboration',
    'Project management',
    'Team communication',
    'Documentation',
    'Knowledge management',
    'Task management',
    
    // Productivity & Automation
    'Workflow automation',
    'Time tracking',
    'Note-taking',
    'File organization',
    'Content management'
  ],
  pricing: ['Free', 'Freemium', 'Paid'],
  platforms: ['Web', 'macOS', 'Windows', 'iOS', 'Android', 'Plugins']
};